import { Asset, Vault, addressEqual } from 'nftx.js';
import { SwapState } from './types';

const getMintableAssets = ({
  mintableAssets,
  filterController,
  sellType,
  sellToken,
  sellVaultId,
  buyToken,
  buyType,
  vaults,
  buyVaultId,
}: Pick<
  SwapState,
  | 'sellVaultId'
  | 'sellType'
  | 'sellToken'
  | 'filterController'
  | 'buyType'
  | 'buyToken'
  | 'buyVaultId'
> & {
  mintableAssets: Asset[] | undefined;
  vaults: Pick<Vault, 'id' | 'vaultId'>[] | undefined;
}) => {
  let assets = mintableAssets?.slice();
  if (!assets) {
    return [];
  }
  // Only show assets for a specific vault
  if (sellType === 'NFT') {
    if (sellVaultId) {
      assets = assets.filter((asset) => {
        return asset.vaultIds.includes(sellVaultId);
      });
    }
    // Only show vaults for a specific collection
    if (sellToken) {
      assets = assets.filter((asset) => {
        return addressEqual(asset.assetAddress, sellToken);
      });
    }
  }
  // If we're buying vToken for a specific vault, only show assets for that vault
  if (
    filterController === 'buy' &&
    buyType === 'vTOKEN' &&
    buyToken &&
    vaults
  ) {
    assets = assets.filter((asset) => {
      const vault = vaults.find((v) => asset.vaultIds.includes(v.vaultId));
      return addressEqual(vault?.id, buyToken);
    });
  }
  // If we're buying NFTs, only show NFTs for that same vault
  if (
    filterController === 'buy' &&
    buyType === 'NFT' &&
    buyToken &&
    buyVaultId
  ) {
    assets = assets
      .filter((asset) => {
        return asset.vaultIds.some((vaultId) => {
          return buyVaultId === vaultId;
        });
      })
      .map((asset) => ({
        ...asset,
        vaultIds: [buyVaultId],
      }));
  }

  assets.sort((a, b) => {
    const aT = BigInt(a.tokenId);
    const bT = BigInt(b.tokenId);

    if (aT > bT) {
      return 1;
    }
    if (aT < bT) {
      return -1;
    }
    return 0;
  });

  return assets;
};

export default getMintableAssets;
